import { render, staticRenderFns } from "./userAdmin.vue?vue&type=template&id=4889c186"
import script from "./userAdmin.vue?vue&type=script&lang=js"
export * from "./userAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports